module.exports = __webpack_public_path__ + "static/media/Martha Smith Headshot_1620677053435.4393d50f.jpeg";